import { RecentlyViewed } from '@theme/recently-viewed-products';
import { formatMoney } from '@theme/money-formatting';

class FenzaRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const currentHandle = this.dataset.currentHandle || '';
    const handles = [...new Set(RecentlyViewed.getHandles())].filter((handle) => handle && handle !== currentHandle);

    if (handles.length < 4) {
      this.hidden = true;
      return;
    }

    const products = (
      await Promise.all(
        handles.slice(0, Number(this.dataset.limit || 4)).map(async (handle) => {
          try {
            const response = await fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`);
            return response.ok ? response.json() : null;
          } catch (_error) {
            return null;
          }
        })
      )
    ).filter(Boolean);

    if (products.length < 4) {
      this.hidden = true;
      return;
    }

    const grid = this.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    grid.replaceChildren(...products.map((product) => this.#createCard(product)));
    this.hidden = false;
  }

  #createCard(product) {
    const link = document.createElement('a');
    link.className = 'fenza-recently-viewed__card';
    link.href = product.url;

    const media = document.createElement('div');
    media.className = 'fenza-recently-viewed__media';
    const featuredImage = product.featured_image || product.images?.[0];
    if (featuredImage) {
      const image = document.createElement('img');
      image.src = featuredImage;
      image.alt = product.title;
      image.loading = 'lazy';
      media.append(image);
    }

    const title = document.createElement('p');
    title.textContent = product.title;
    const priceRow = document.createElement('div');
    priceRow.className = 'fenza-recently-viewed__price';

    const price = document.createElement('span');
    price.textContent = formatMoney(
      Number(product.price || 0),
      this.dataset.moneyFormat || '{{amount}}',
      this.dataset.currency || 'TRY'
    );
    priceRow.append(price);

    if (Number(product.compare_at_price || 0) > Number(product.price || 0)) {
      const compareAtPrice = document.createElement('s');
      compareAtPrice.className = 'fenza-recently-viewed__compare-at';
      compareAtPrice.textContent = formatMoney(
        Number(product.compare_at_price),
        this.dataset.moneyFormat || '{{amount}}',
        this.dataset.currency || 'TRY'
      );
      priceRow.append(compareAtPrice);
    }

    link.append(media, title, priceRow);
    return link;
  }
}

if (!customElements.get('fenza-recently-viewed')) {
  customElements.define('fenza-recently-viewed', FenzaRecentlyViewed);
}
